// opervex-frontend/src/Opervex/System/Setting.js
class Setting {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  async create(data) {
    return this.#_api.post("/System/Setting/", data);
  }

  async update(id, data) {
    return this.#_api.put("/System/Setting/" + id, data);
  }

  async findId(id) {
    return await this.#_api.get("/System/Setting/" + id);
  }

  async findAll() {
    return await this.#_api.get("/System/Setting");
  }
}

export default Setting;
